// src/components/share/ShareCard.tsx
import React from "react";
import { useTranslation } from "react-i18next";

export interface ShareCardProps {
  backgroundImage: string;      // 背景图：已经包含顶部提问 & 底部 INNERGEM logo
  title?: string;
  subtitle?: string;
  mainText: string;             // AI Insight 文本
  tagline?: string;
  mode?: "spark" | "guided";      // 先保留这个字段，将来要用还可以再加回视觉
}

export const ShareCard: React.FC<ShareCardProps> = ({
  backgroundImage,
  mainText,
}) => {
  const { t } = useTranslation();
  // --- 字数限制，避免撑爆白色卡片 ---
  const MAX_CHARS = 520;
  const cleaned = (mainText ?? "").trim();
  const truncatedText =
    cleaned.length > MAX_CHARS
      ? cleaned.slice(0, MAX_CHARS).trimEnd() + "…"
      : cleaned;

  return (
    <div className="w-[1080px] h-[1920px] overflow-hidden shadow-2xl bg-black/5">
      {/* 背景图本身已经有提问 & 底部 logo/title */}
      <div
        className="relative w-full h-full"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* 中间：白色半透明圆角卡片 */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="
              w-[760px]
              rounded-[32px]
              bg-white/50
              backdrop-blur-[3px]
              shadow-[0_18px_60px_rgba(15,23,42,0.32)]
              px-12 pt-4 pb-10
              border border-white/70
            "
          >
            {/* 顶部：只保留标题 */}
            <div className="mb-4 text-center">
              <span className="block text-[35px] font-semibold text-slate-900">
                {t("shareCard.title", { defaultValue: "My Inner Gem AI Insight" })}
              </span>
            </div>

            {/* 内容正文 */}
            <p className="whitespace-pre-line text-[30px] leading-relaxed text-slate-900 text-center">
              {truncatedText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
